module.exports = __webpack_public_path__ + "block-2-2x-5feb9a31cb446ecacae121703d47b681.webp";